/* eslint-disable import/prefer-default-export */
/** Users */
import { combineReducers } from 'redux';

import headerReducer from './header/headerSlice';
import userReducer from './user/userSlice';

const appReducer = combineReducers({
  header: headerReducer,
  user: userReducer,
});

export const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    state = undefined;
  }

  return appReducer(state, action);
};
